package pl.decks.personal.components.widgets.tag

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun TagsList(modifier: Modifier = Modifier, content: @Composable RowScope.() -> Unit) =
    Row(
        modifier = TagStylesheet.Listing.toModifier().then(modifier),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        content()
    }